import { Carousel } from "@material-tailwind/react";
 import oil1 from '../../images/b551154a-fe0f-482b-a877-ae4b39d7b694.jpg'
export default function CarouselCustomNavigation() {
  return (
    <Carousel
      className=""
      style={{height:'90vh'}}
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div className="absolute bottom-4 left-2/4 z-50 flex  gap-2">
          {new Array(length).fill("").map((_, i) => (
            <span
              key={i}
              className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
              }`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      )}
    >
      <img
      src={oil1}
        alt="image 1"
        className="h-full w-full object-cover"
      />
      <img
        src="https://salonioil.com/wp-content/uploads/2021/05/dal-pakwan-min.jpg"
        alt="image 2"
        className="h-full w-full object-cover"
      />
      <img
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSE-M2mFlCdsSlD_arqBozX7vrsTDZ8sgUYlK6AFfgMcXiTiiN6i979Kc0ab0LHhIJXzU&usqp=CAU"
        alt="image 3"
        className="h-full w-full object-cover"
      />
    </Carousel>
  );
}